import React from 'react';
import Button from '../../../framework/Button/Button';
import AcquireWebComponent from '../../../framework/MaterialUI/index'

import ChannelCampaignsTable from '../../ChannelCampaignsTable';
import AddCampaignDialog from './AddCampaignDialog';

import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import union from 'lodash/union';
import { convertColorToString } from 'material-ui/utils/colorManipulator';

class DeploymentCampaigns extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      deployName: undefined
    }
  }
  removeCampaignId(id){
    this.setState({openDelConfirm: true, removeCampaignId: id});
  }
  
  onAddSegmentBtnClick(e, name) {
    e.preventDefault();
    this.props.onClickAddSegment();
    this.setState({
      openDialog:true,
      deployName: name
    })
  }
  onRequestClose() {
    this.setState({
      openDialog:false
    })
  }
  render() {
    const {campaigns, viewMode, title, parentCampaignDetail, legacy} = this.props;
    const sourceCampaigns = this.props.parentCampaignDetail ? 
      filter(this.props.parentCampaignDetail.channelCampaigns, 
        (campaign)=>{return campaign.channel.toLowerCase() === this.props.title.toLowerCase()}) : [];

    const dialogTitle = this.props.title === 'SOCIAL' ? "FACEBOOK" : this.props.title === "DISPLAY" ? 
    "Google Ads" : this.props.title
    let sltIds = []
    let hideIds = []

    map(campaigns, (deployCampaign)=>{
      const ids = map(deployCampaign.channelCampaigns, "id");
      if (deployCampaign.name === this.state.deployName) {
        sltIds = union(ids, sltIds)
      } else {
        hideIds = union(ids, hideIds)
      }
    })

    const displayCampaigns = filter(this.props.channelCampaigns, (channelCampaign)=>{
      return hideIds.indexOf(channelCampaign.id) < 0;
    })

    if (parentCampaignDetail){
      map(parentCampaignDetail.campaignDeployments, deployment=>{
        if (deployment.channel.toLowerCase() === this.props.title.toLowerCase()){
          if (deployment.name === this.state.deployName) {
            map(deployment.channelCampaigns, channelCampaign => {
              if (filter(campaigns, campaign=>{
                return channelCampaign.channel.toLowerCase() === campaign.channel.toLowerCase() && channelCampaign.id === campaign.id
              }).length <= 0) {
                displayCampaigns.push(channelCampaign)
              }
            })
          } else {
            map(deployment.channelCampaigns, channelCampaign => {
              let isRemoved = true;
              map(campaigns, campaign=>{
                if (channelCampaign.channel.toLowerCase() === campaign.channel.toLowerCase() && map(campaign.channelCampaigns, "id").indexOf(channelCampaign.id) >= 0 && isRemoved === true){
                  isRemoved = false;
                }
              })
              if (isRemoved === true)
                displayCampaigns.push(channelCampaign)
            })
          }
        }
      })
    }
    return (
      <div>
        <AddCampaignDialog open={this.state.openDialog} title={dialogTitle}
          applyChange={this.props.onApplyCampaignChanges }
          onRequestClose={this.onRequestClose.bind(this)}
          channelCampaigns={displayCampaigns}
          campaignName={this.props.parentCampaignDetail ? this.props.parentCampaignDetail.name : this.props.campaignName}
          emailCampaigns={sourceCampaigns}
          channelType={title.toLowerCase()}
          campaignStatus={this.props.campaignStatus}
          selectCampaignIds={sltIds}
          startDate={this.props.startDate} endDate={this.props.endDate}
          deployName={this.state.deployName}
        />
        {
          map(campaigns, (deploy, idx)=>{
            
            const displayCampaigns = isEmpty(deploy.channelCampaigns) || (!deploy.channelCampaigns[0].name) ?  
            filter(this.props.channelCampaigns, campaign=>{
              return filter(deploy.channelCampaigns, deployCampaign=> {return deployCampaign.id === campaign.id}).length > 0
            }) :  deploy.channelCampaigns

            return (
              <div className={legacy ? "deployment-legacy-section" : "deployment-section"} style={{paddingLeft: legacy ? "0" : '0px', marginTop: legacy ? "5px" : "20px"}} 
                key={deploy.name + "-container"}>
                <div style={{width:'100%', height:'45px', background:"#CDCDCD", fontWeight:'bold', position:'relative', textOverflow:"ellipsis",
                    display: legacy?"none":"block", overflow:"hidden", whiteSpace:"nowrap"}} 
                  className="pt-10 pb-5 pl-20 pr-20 deployment-title">
                  <div className={this.state[`collapsed${idx}`] ? "arrow-right" : "arrow-down"} onClick={()=>{this.setState({[`collapsed${idx}`]:!this.state[`collapsed${idx}`]})}}></div>
                  Deployment {idx+1} - {deploy.name} 
                  {
                    !viewMode &&
                  <a onClick={(e)=>{e.preventDefault();this.props.onDelDeployment(deploy.name)}}>
                    <i className="icon-cancel-circle2" style={{color:"red", position:"absolute", top:"13px", right:'21px'}}></i>
                  </a>
                  }
                  </div>
                  
                {
                  (!isEmpty(deploy.channelCampaigns) && !this.state[`collapsed${idx}`]) && 
                <ChannelCampaignsTable tableHeaderArr={
                  [
                    {label: 'Segment Name', value: 0},
                    {label: 'Segment ID', value:1},
                    {label: 'Segment Start Date', value: 2},
                    {label: 'Segment End Date', value: 3},
                    {label: 'Status', value: 4},
                    {label: '', value:5}
                  ]
                } activeIndex={0} bodyDataArr={displayCampaigns} showSelectBox={false} sortable={false}
                bodyDataKey={['select','name', 'campaignId','startDate','endDate','status']}
                tableHeaderWidthStyle={
                  [ '40%', '16%', '15.5%', '15%', '10%']
                } showDelBtn={!viewMode} removeCampaignId={(id)=>{this.props.removeCampaignId(id, deploy.name)}} narrowHeader={true}
                />
                }
                <div className="mt-10">{
                  (!viewMode) && [
                    <div className="pt-10 pb-10 light-grey-top-border light-grey-bottom-border mb-10" 
                      style={{display:displayCampaigns.length > 0 ? "none" : "block", textAlign:"center"}}>No segment(s) have been added</div>,
                    <Button title="Add Segment" disabled={deploy.channelCampaigns.length >= 10}
                    handleClick={(e)=>{this.onAddSegmentBtnClick(e, deploy.name)}}/>
                  ]

                  }
                </div>
              </div>
            )
          })
        }
        {
          isEmpty(campaigns) ? <section className="no-data" style={{fontSize:"16px"}}>
            {"No deployment(s) have been added."}
          </section> : ""
        }
      </div>
    )
  }
}

export default DeploymentCampaigns

DeploymentCampaigns.protoTypes = {
  campaignss:React.PropTypes.array.isRequired,
  viewMode: React.PropTypes.bool.isRequired,
  onApplyCampaignsChange: React.PropTypes.func.isRequired,
  campaignName: React.PropTypes.string.isRequired,
  legacy: React.PropTypes.bool.isRequired
}

DeploymentCampaigns.defaultProps = {
  campaigns: [],
  viewMode: true,
  legacy: false
}


// WEBPACK FOOTER //
// ./src/components/Campaigns/CreateCampaigns/AddCampaign/deploymentCampaigns.jsx